import React, { useContext } from 'react'
import { Locale } from 'contexts/locale'
import IntlMessageFormat from 'intl-messageformat'
import totalConsumptionData, { CountryData } from 'data/total-consumption.csv'
import { extractValue } from 'lib/extractValue'
import { Consumption } from 'contexts/consumption'
import { getMemoisedYearlyConsumption } from 'lib/calculations'
import { comparisonScale } from 'lib/comparisonScale'

/**
 * Compare the personal consumption of a user with the average consumption within Switzerland.
 */
export function AverageComparison() {
  const locale = useContext(Locale)
  const consumption = useContext(Consumption)
  const messages = require('./locales/' + locale + '.yml')
  const switzerland: CountryData = totalConsumptionData.find(
    value => value.Country === 'Switzerland'
  ) as CountryData
  const averageConsumption = extractValue(
    switzerland[consumption.isFemale ? 'Female' : 'Male']
  ) as number
  const resultMessage = new IntlMessageFormat(
    messages['result'],
    locale + '-CH'
  )

  const difference =
    getMemoisedYearlyConsumption(consumption) - averageConsumption

  return (
    <p
      dangerouslySetInnerHTML={{
        __html: resultMessage.format({
          diff: Math.abs(difference) / averageConsumption,
          quality: difference < 0 ? 'less' : 'more',
          gender: consumption.isFemale ? 'female' : 'male',
          comparison: comparisonScale(difference / averageConsumption)
        })
      }}
    />
  )
}
